import React, { Fragment } from 'react';
import { PATH_TRIAL_NUMBERS } from '~/common/utils/consts';

import Header from '~/common/components/Header';
import HeaderGroup from '~/common/components/HeaderGroup';
import CommonButton from '~/common/components/CommonButton';

import errorIcon from '~/common/images/error-icon.svg';

import styles from './error-view.css';

const ErrorView = () => {
    return (
        <Fragment>
            <Header />
            <section className={styles.wrapper}>
                <HeaderGroup>
                    <h1>Oops something went wrong!</h1>
                </HeaderGroup>
                <img className={styles.image} src={errorIcon} />
                <CommonButton
                    alternateColor={true}
                    arrow={true}
                    href={PATH_TRIAL_NUMBERS}
                    modifier={styles.button}
                >
                    Start over with free trial
                </CommonButton>
                <p className={styles.copy}>Actually, I'm ready to <a className={styles.link} href='/'>buy.</a></p>
            </section>
        </Fragment>
    );
};

export default ErrorView;
